import React from "react";
import { Row, Typography, Form, Col, Divider, Select, Input, InputNumber } from "antd";
import { BOM } from "../../../../../services/definedMethod";
const { Title, Text } = Typography;

const BalanceManagement = (props) => {
  const { onFinish, form, formData, templateData } = props;
  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Balance Management
        </Title>
      </Divider>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="openingBalance"
            label={<Text strong>Opening Balance</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Opening Balance"),
              },
            ]}
          >
            <InputNumber
              // type="number"
              min={0}
              placeholder={BOM.handlePlaceholderMsg("Opening Balance")}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="minimumBalanceAllowed"
            label={<Text strong>Minimum Balance Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Minimum Balance Allowed"),
              },
            ]}
          >
            <InputNumber
              // type="number"
              min={0}
              placeholder={BOM.handlePlaceholderMsg("Minimum Balance Allowed")}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="maximumBalanceAllowed"
            label={<Text strong>Maximum Balance Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Maximum Balance Allowed"),
              },
            ]}
          >
            <InputNumber
              // type="number"
              min={0}
              placeholder={BOM.handlePlaceholderMsg("Maximum Balance Allowed")}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="overdraftAllowed"
            label={<Text strong>Overdraft Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Overdraft Allowed"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Overdraft Allowed")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default BalanceManagement;
